import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Typography,
  useTheme
} from "@mui/material"
import React from "react"
import { useDispatch } from "react-redux"
import {
  remove,
  useConfirmationNotification
} from "store/modules/common/notify"
import { Dialog } from "shared/ui/berry-jass"
import { Translate } from "utils/i18n-shim"

export const ConfirmationDialog = () => {
  const notification = useConfirmationNotification()
  const theme = useTheme()
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(remove(notification.id))
  }

  const handleCancel = () => {
    if (notification.onCancel) {
      notification.onCancel()
    }

    handleClose()
  }

  const handleConfirm = () => {
    if (notification.onConfirm) {
      notification.onConfirm()
    }
    handleClose()
  }

  if (!notification) {
    return null
  }

  return (
    <Dialog
      open
      onClose={handleCancel}
      title={notification.title}
      maxWidth="lg"
      data-testid="confirmation-dialog"
    >
      <DialogContent sx={{ mt: 3 }}>
        <Box
          sx={{
            [theme.breakpoints.up("md")]: {
              minWidth: "600px"
            }
          }}
        >
          <Typography gutterBottom variant="body1">
            {notification.message}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ gap: 1 }}>
        {(notification.showCancel ?? true) && (
          <Button
            variant="outlined"
            size={notification.buttonSize ?? "medium"}
            onClick={handleCancel}
          >
            {notification.cancelBtnText ?? <Translate value="actions.cancel" />}
          </Button>
        )}
        <Button
          variant="contained"
          size={notification.buttonSize ?? "medium"}
          onClick={handleConfirm}
        >
          {notification.confirmBtnText ?? <Translate value="actions.ok" />}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
